/**
 * This file is the entryPoint for cleaning Request parameter before
 * to request API data. Specify transform request living in transformRequest folder. There
 * should be one transform by endpoint or component but never one transform
 * use by diferents endpoints.
 *
 *  When you create specify transform  review which parameters you
 *  need to delete by example airports is the paramas living in the prePopulation
 *  and if you used the current way to pass request to integration layer
 *  always you have to delete this params in airports consumer component. In the
 *  future will added to this layer a helper transformCommon to delete params
 *  like airport and you only need call this method.
 */

/**
 * Delete from Request object all params
 * @param {*} request  Request object
 * @param {*} params   params to delete
 * @param {*} paramsEmpty   params to delete when is empty
 */
const transformRequest = (request, params = [], paramsEmpty = []) => {
  // Copy request to prevent side effec :) By example maybe originCity
  // is not necessary for a endpoin but if you delete this from
  // prepPopulation object then logic component using this parameter
  // is losed. Because this layer used inmutability you need to return
  // request from your transform because the param request never is mutable
  const requestCopy = { ...request };

  // REmove value don't matter the value
  if (params) {
    params.forEach((param) => {
      if (param in requestCopy) {
        requestCopy[param] = null;
        delete requestCopy[param];
      }
    });
  }

  // Remove params with empty value
  if (paramsEmpty) {
    paramsEmpty.forEach((param) => {
      if (param in requestCopy && requestCopy[param].length === 0) {
        requestCopy[param] = null;
        delete requestCopy[param];
      }
    });
  }

  // This return request object after clean unwanted parameters
  return requestCopy;
};

export default transformRequest;
